import React from "react";

export function CursorIcon() {
  return (
    <svg viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor" aria-hidden="true">
      <path d="M5 3l14 9.5L11 14l-2 7L5 3z" />
    </svg>
  );
}

export function ClaudeIcon() {
  return (
    <svg viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor" aria-hidden="true">
      <path d="M12 3c.5 2.5 2.2 4.7 4.7 5.3-2.5.6-4.2 2.8-4.7 5.3-.5-2.5-2.2-4.7-4.7-5.3C9.8 7.7 11.5 5.5 12 3zm0 6.5c.3 1.5 1.3 2.8 2.8 3.2-1.5.4-2.5 1.7-2.8 3.2-.3-1.5-1.3-2.8-2.8-3.2 1.5-.4 2.5-1.7 2.8-3.2z" />
    </svg>
  );
}
